var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2652 3.32172C4.6398 2.9159 5.27246 2.89059 5.67828 3.26519L11.5466 8.6821L18.3753 3.21913C18.8066 2.87412 19.4359 2.94404 19.7809 3.3753C20.1259 3.80656 20.056 4.43586 19.6247 4.78087L12.1247 10.7809C11.7387 11.0897 11.185 11.0701 10.8217 10.7348L4.32172 4.7348C3.9159 4.3602 3.8906 3.72754 4.2652 3.32172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2652 13.3217C4.6398 12.9159 5.27246 12.8906 5.67828 13.2652L11.5466 18.6821L18.3753 13.2191C18.8066 12.8741 19.4359 12.944 19.7809 13.3753C20.1259 13.8066 20.056 14.4359 19.6247 14.7809L12.1247 20.7809C11.7387 21.0897 11.185 21.0701 10.8217 20.7348L4.32172 14.7348C3.9159 14.3602 3.8906 13.7275 4.2652 13.3217Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFold);
export default __webpack_public_path__ + "static/media/Icon_Fold.8b0a65a5144a74b4f10f15ab2b5afbd2.svg";
export { ForwardRef as ReactComponent };